import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

const PaymentCancel = () => (
  <div className="min-h-screen bg-cream flex items-center justify-center px-6 pt-24" data-testid="payment-cancel-page">
    <div className="text-center max-w-md">
      <span className="mx-auto w-16 h-16 rounded-full bg-blush/60 grid place-items-center">
        <XCircle size={30} className="text-teal" />
      </span>
      <h1 className="font-display font-bold text-4xl text-teal mt-6">Payment Cancelled</h1>
      <p className="mt-4 text-teal/70 leading-relaxed">
        No charge was made. Your items are still reserved at the counter for 48 hours —
        or you can try paying by card again.
      </p>
      <Link to="/shop" data-testid="cancel-back-link"
        className="mt-8 inline-block rounded-full bg-teal text-cream px-8 py-3.5 text-xs uppercase tracking-[0.2em] hover:bg-gold hover:text-teal-deep transition-colors">
        Back to the Shop
      </Link>
    </div>
  </div>
);

export default PaymentCancel;
